import { ActivatedRoute } from '@angular/router';
import { Constants } from '../../../constants/constants';
import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { DAXQueryDto } from '../../../dto/powerbi/dax.query.dto';
import { PowerbiService } from '../../../services/powerbi.service';
import { ResponseEmbedconfigDto } from '../../../dto/powerbi/response.embedconfig.dto';
import { PowerBiEmbedComponent } from '../../util/power-bi-embed/power-bi-embed.component';
import { SlicerDto } from '../../../dto/powerbi/slicer.dto';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrl: './report.component.scss',
})
export class ReportComponent implements OnInit {
  // Define Variables
  reportMetaId: string = 'SIC';
  embedUrl!: string;
  embedToken!: string;
  accessToken!: string;
  reportId!: string;
  groupId!: string;
  renderizarReporte = false;
  totalDatos!: string;
  descripcion!: string;
  downloadFlag: boolean = false;

  // Define Zoom
  isZoomEnabled: boolean = true;

  // Define Mobile
  isMobile: boolean = true;

  // Define dinamic height
  height: string = '800px';

  // Define SuperAdmin
  esSuperAdmin: boolean = false;

  @ViewChild('reporte') reporte!: PowerBiEmbedComponent;

  // Define Constructor
  constructor(
    private route: ActivatedRoute,
    private pbiService: PowerbiService
  ) {}

  // Define ngOnInit
  ngOnInit(): void {
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}'
    );
    this.esSuperAdmin = infoInicioSesion.Nombre === 'Superadministrador';
    const reportMetaId = this.route.snapshot.paramMap.get('id');
    this.reportMetaId = reportMetaId ? reportMetaId : this.reportMetaId;
    let query = `EVALUATE FILTER('metadata OBJ_Meta_Tablero','metadata OBJ_Meta_Tablero'[Tablero] = "${reportMetaId}")`;
    let dto: DAXQueryDto = {
      datasetId: 'portal',
      query: query,
    };
    this.pbiService.getViewBag(dto).subscribe(response => {
      this.descripcion = response[0]['metadata OBJ_Meta_Tablero[Descripcion]'];
      this.totalDatos = response[0]['metadata OBJ_Meta_Tablero[Total]'];
    });
    this.pbiService
      .getReporte(this.reportMetaId)
      .subscribe((data: ResponseEmbedconfigDto) => {
        this.embedUrl = data.reportDetails.embedUrl;
        this.embedToken = data.embedToken.token;
        this.accessToken = data.accessToken;
        this.reportId = data.reportDetails.id;
        this.groupId = data.reportDetails.workspaceId;
        this.renderizarReporte = true;
      });
    this.adjustHeight();
  }

  // Define download table
  downloadTable() {
    this.downloadFlag = true;
  }

  // Define redirigirAdm
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.adjustHeight();
  }

  // Define adjustHeight
  adjustHeight(): void {
    if (this.isMobile) {
      this.height = '800px';
      return;
    }
    const windowWidth = window.innerWidth;
    this.height = `${windowWidth * 0.3}px`;
  }

  // Define redirigirAdm
  redirigirAdm() {
    window.open(Constants.FRABIC_ADM, '_blank');
  }

  async getFilters(): Promise<SlicerDto[]> {
    return await this.reporte.getReportSlicers();
  }
}
